// extracted by mini-css-extract-plugin
export var isContentCentered = "row-module--isContentCentered--d5kuD";
export var row = "row-module--row--+RX3p";